import { createReducer } from 'typesafe-actions';

import { IRouteState, RouteActionTypes, TRouteAction } from '../types';

const initialState = {
  title: undefined,
  path: undefined,
};

export const routeReducer = createReducer<IRouteState, TRouteAction>(initialState)
  .handleType(RouteActionTypes.SET_ROUTE, (state, action) => {
    return {
      ...state,
      ...action.route,
    };
  })
  .handleType(RouteActionTypes.SET_ROUTE_PATH, (state, action) => ({
    ...state,
    path: action.path,
  }))
  .handleType(RouteActionTypes.SET_ROUTE_TITLE, (state, action) => ({
    ...state,
    title: action.title,
  }));
